// extracted by mini-css-extract-plugin
export default {"1100":"(min-width: 1100px)","root":"UO5hq8t0aAgU1XL5vyRZ","wrap":"B4d6JIBjvI89rf2ZjE5t","btn":"KpdCH02weKw0V9I2_4a7","banner":"trcTzIlQjqU7LWZfW3x_"};